import { axiosPublic } from './axiosInstance';
import axiosInstance from './axiosInstance';

export async function login(email, password) {
  const response = await axiosPublic.post('/v1/auth/login', { email, password });

  // AccessToken: Authorization 헤더 또는 응답 바디
  const authHeader = response.headers['authorization'] || response.headers['Authorization'];
  const accessToken =
    (authHeader ? authHeader.replace('Bearer ', '') : null) ||
    response.data?.data?.accessToken ||
    response.data?.accessToken;

  // RefreshToken: 응답 바디 또는 쿠키
  const refreshToken =
    response.data?.data?.refreshToken ||
    response.data?.refreshToken ||
    getCookieValue('refreshToken');

  return { accessToken, refreshToken };
}

export async function logout(refreshToken) {
  await axiosInstance.post('/v1/auth/logout', { refreshToken });
}

export async function refreshAccessToken(refreshToken) {
  const response = await axiosPublic.post('/v1/auth/refresh', { refreshToken });
  return response.data?.data ?? response.data;
}

export async function sendPasswordResetCode(email) {
  await axiosPublic.post('/v1/auth/password-reset/send-code', { email });
}

export async function verifyPasswordResetCode(email, code) {
  const response = await axiosPublic.post('/v1/auth/password-reset/verify-code', { email, code });
  return response.data?.data?.verificationToken ?? response.data?.verificationToken;
}

export async function resetPassword(email, verificationToken, newPassword) {
  await axiosPublic.post('/v1/auth/password-reset/reset', {
    email,
    verificationToken,
    newPassword,
    newPasswordConfirm: newPassword,
  });
}

function getCookieValue(name) {
  const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
  return match ? decodeURIComponent(match[2]) : null;
}
